import React from "react";

import "../../../styles/tutorial.scss";

function TimeCerto({ name }) {
  return (
    <div class="container_como_jogar">
      <div>
        <h1 className="center capitalize">{name}</h1>

        <p>
          Já pensou em vibrar apostando no seu time ou liga do coração sem ele
          nem estar jogando?! Aqui você pode! No{" "}
          <b className="capitalize">{name}</b>, a cada 10 minutos é sorteado um
          time/liga em uma roleta com 50 times. Com prêmio máximo de até
          R$120.000,00 mil, baseado no time/liga e valor apostado.
        </p>
      </div>
    </div>
  );
}

export default TimeCerto;



// WEBPACK FOOTER //
// ./src/static/tutorial/time-certo/default.jsx